import cn from "./cn.json";

const locales = {
  cn,
};

export default locales;
